<template>
  <v-container fluid class="custom-section pa-0">
    <v-container class="text-center max-1300 pa-0">
      <v-row>
        <v-col>
          <h2 v-html="title" />
        </v-col>
      </v-row>
      <v-row class="padding-big">
        <v-col cols="12" md="4" class="pt-4 pt-md-2" v-for="col in cols" :key="col.html">
          <p class="section-content mb-6" v-html="col.html" />
          <v-img
            eager
            :src="col.img"
            :lazy-src="col.lazy"
            class="ma-auto custom-image"
            />
        </v-col>
      </v-row>
    </v-container>
  </v-container>
</template>
<script>
export default {
  props: {
    cols: Array,
    title: String,
    class: String,
    background: {
      String,
      default: 'bg-white',
    },
  },
};
</script>

<style lang="scss">
  .first-section {
    margin-top: 100vh;
  }

  .max-1300 {
    max-width: 1300px;
    margin: 0 auto;
  }

  .custom-section {
    position: relative;
    z-index: 9;
  }

  .bg-grey {
    background-color: #F4F4F4;
  }

  .bg-white {
    background-color: #fff;
  }

  .section-content {
    font-weight: 300;
    line-height: 1.23;
    letter-spacing: .22px;
    color: #243236;

    strong {
      font-weight: 700;
    }
  }

  .padding-big {
    padding-bottom: 4.25rem;
  }

  .v-responsive {
    &.custom-image {
      max-width: 300px;
    }
  }

  @media screen and (max-width: 960px) {
    .first-section {
      margin-top: 0vh;
    }

  .v-responsive {
    &.custom-image {
      max-width: 250px;
    }
  }
  }

  @media screen and (max-height: 765px) {
    .first-section {
      margin-top: 0vh;
    }
  }

  @media screen and (max-width: 512px) {
    .v-responsive {
      &.custom-image {
        max-width: 200px;
      }
    }
  }
</style>
